<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="">会员中心</router-link></li>
                <li class="currentNode"><a>我的驻京美食</a></li>
            </ul>
            <div class="page-main">
                <person-center-menu></person-center-menu>
                <div class="page-content">
                    <h3>
                        <span>推荐菜</span>
                        <button class="addUpload" @click="addRecommend()"><i class="el-icon-circle-plus"></i>添加</button>
                    </h3>
                    <el-divider></el-divider>
                    <el-table
                        class="theadTable"
                        :data="tableData">
                        <el-table-column
                            label="ID"
                            width="150"
                            prop="ImageId">
                        </el-table-column>
                        <el-table-column
                            label="菜品名称"
                            min-width="200"
                            prop="Title">
                        </el-table-column>
                        <el-table-column
                            label="照片"
                            min-width="250">
                            <template slot-scope="scope">
                                <img :src="scope.row.ImageUrl" class="recommendation-img" />
                            </template>
                        </el-table-column>
                        <!-- <el-table-column
                            label="排序"
                            width="120"
                            prop="AvgPrice">
                        </el-table-column>
                        <el-table-column
                            label="状态"
                            width="100">
                            <template slot-scope="scope">
                                {{ scope.row.Status | checkStatus}}
                            </template>
                        </el-table-column> -->
                        <el-table-column
                            label="操作"
                            width="100">
                            <template slot-scope="scope">
                                <el-button class="textBtn" @click="goEdit(scope.row)" type="text">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <add-recommend-modal @getDishesList="getDishesList" ref="addRecommendModal"></add-recommend-modal>
    </div>
</template>

<script>
import PersonCenterMenu from '@/components/personCenterMenu.vue'
import {
    getDishesList
} from '@services/tokenService.js';
import AddRecommendModal from './addRecommendModal.vue'

export default {
    components: {
        AddRecommendModal,
        PersonCenterMenu
    },
    name: '',
    data() {
        return {
            shopId: '',
            tableData: [],
        };
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
        companyId() {
            return this.$store.state.permission.companyId;
        },
    },
    created() {
        if (this.accountId === '') {
            this.$router.push(
                {
                    path: '/layout/login',
                }
            );
        }
        if(this.$route.query.id) {
            this.shopId = this.$route.query.id;
            this.getDishesList();
        } else {
            this.$router.push(
                {
                    path: '/layout/my-food',
                }
            );
        }
    },
    methods: {
        getDishesList() {
            let params = {
                shopid: this.shopId,
            };
            getDishesList(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.tableData = res.Data;
                    this.total = res.Count;
                } else {
                    this.$message.error("我的驻京美食请求失败");
                }
            })
        },
        addRecommend() {
            this.$refs.addRecommendModal.show();
        },
        goEdit(data) {
            this.$refs.addRecommendModal.show(data);
        },
    },
    filters: {
        checkStatus(values) {
            if (values === null) {
                return '';
            }
            let checkStatusList = [
                {
                    label: '审核通过',
                    value: '10'
                },
                {
                    label: '审核失败',
                    value: '-10'
                },
                {
                    label: '待审核',
                    value: '0'
                },
            ];
            for(let i=0;i<checkStatusList.length;i++) {
                if (checkStatusList[i].value == values) {
                    return checkStatusList[i].label;
                }
            }
            return '';
        }
    }
};
</script>

<style scoped>
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: left;
    margin-bottom: 0;
    padding-bottom: 0;
    display:flex;
    justify-content: space-between;
    align-items: center;
}
.theadTable {
    box-shadow: -2px -2px 16px 1px #00000026;
    margin-bottom: 30px;
}
.vertical-nav li a.active {
    border-left: none;
}
.textBtn {
    color: #2e8cd8;
}
.recommendation-img {
    width: 145px;
    height: 92px;
    margin: 0 auto;
}
.el-upload .el-button:focus, 
.el-upload .el-button:hover{
    background-color: #ecf5ff;
    color: #116EBA; 
}
</style>